// @flow
import Environment from "./environment";

"use strict";

/**
 * gulp経由でsetting.jsonから渡される外部情報
 */
export default class PlacementSetting {
  constructor(placementCode: string, placementId: number, headerText: string, publishedAtFmt: string, environment: Environment, sentryDSN: string){
    this.placementCode = placementCode; // プレイスメントコード
    this.placementId = placementId; // プレイスメントID
    this.headerText = headerText; // ヘッダーテキスト
    this.publishedAtFmt = publishedAtFmt; // 記事作成日表示フォーマット
    this.environment = environment; // 実行環境文字列 local|development|staging|production
    this.sentryDSN = sentryDSN; // sentryDSN
  }

  static create(json: Object): PlacementSetting{
    try {
      PlacementSetting.validate(json);
      return new PlacementSetting(json.placement_code, json.placement_id, json.header_text, json.published_at_fmt, json.environment, json.sentryDSN);
    } catch(e){
      throw e;
    }
  }

  static validate(json: Object){
    // 必須パラメータ
    if(!json.placement_code){
      throw new Error(`PlacementSetting:can't load json.placement_code`);
    }

    if(!json.placement_id){
      throw new Error(`PlacementSetting:can't load json.placement_id`);
    }

    if(!json.environment){
      throw new Error(`PlacementSetting:can't load json.environment`);
    }

    // 空文字でもOKなパラメータ
    if(!('header_text' in json)){
      throw new Error(`PlacementSetting:can't load json.header_text`);
    }

    if(!('published_at_fmt' in json)){
      throw new Error(`PlacementSetting:can't load published_at_fmt.placement_code`);
    }

    if(!('sentryDSN' in json)){
      throw new Error(`PlacementSetting:can't load json.environment`);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/model/common/placement-setting.js